import React from "react";
import "./PriorityBadge.css";

/**
 * Shared PriorityBadge component.
 *
 * @param {string} priority   - e.g. "Urgent", "High", "Medium", "Low", "Critical"
 * @param {"pill"|"dot"}      - "pill" = colored background chip (default, used in Backlog)
 *                              "dot"  = coloured dot + text (used in Dashboard tables)
 */
const PriorityBadge = ({ priority, variant = "pill" }) => {
  const key = String(priority || "").toLowerCase();

  if (variant === "dot") {
    // Existing dashboard-table style — coloured dot + plain text
    const tone =
      key === "critical" || key === "urgent" ? "critical"
      : key === "high"   ? "high"
      : key === "low"    ? "low"
      : "medium";

    return (
      <span className={`pb-dot pb-dot--${tone}`}>
        <span className="pb-dot__circle" aria-hidden="true" />
        {priority}
      </span>
    );
  }

  // Default: pill style (coloured background chip)
  const tone =
    key === "urgent" || key === "critical" ? "urgent"
    : key === "high"   ? "high"
    : key === "low"    ? "low"
    : "medium";

  return (
    <span className={`pb-pill pb-pill--${tone}`}>
      {priority}
    </span>
  );
};

export default PriorityBadge;
